import { jsx as _jsx } from "react/jsx-runtime";
const TwitchEmbed = ({ link }) => {
    const channel = link.split("/").slice(-1);
    const args = `?channel=${channel}&parent=${window.location.hostname}&muted=true`;
    return _jsx("iframe", { src: `https://player.twitch.tv/${args}`, className: "w-max", allowFullScreen: true });
};
export default TwitchEmbed;
